///<reference path="./gl-matrix.d.ts"/>
import Vector3 from "./Vector3";
/**
 * Axis-Aligned Bounding Box implementation
 */
class AABB {
    constructor(initialPoints) {
        if (initialPoints) {
            initialPoints.forEach(f => this.expand(f));
        }
    }
    /**
     * Width of this AABB
     */
    get Width() {
        return Math.abs(this.pointLBF.X - this.pointRTN.X);
    }
    /**
     * Height of this AABB
     */
    get Height() {
        return Math.abs(this.pointLBF.Y - this.pointRTN.Y);
    }
    /**
     * Distance of this AABB
     */
    get Distance() {
        return Math.abs(this.pointLBF.Z - this.pointRTN.Z);
    }
    get Center() {
        return this._center ? this._center : (this._center = Vector3.add(this.pointLBF, this.pointRTN).multiplyWith(0.5));
    }
    /**
     * Calculate new bounding box with considering the new point is included.
     * @param  {Vector3} newPoint the point that will be considered that it should be in this bounding box.
     */
    expand(newPoint) {
        if (this.pointLBF == null) {
            // assume this is first time to be used this AABB instance
            this.pointLBF = Vector3.copy(newPoint);
            this.pointRTN = Vector3.copy(newPoint);
        }
        this.pointLBF = Vector3.min(newPoint, this.pointLBF);
        this.pointRTN = Vector3.max(newPoint, this.pointRTN);
        this._center = null;
        return this;
    }
    /**
     * Clean up this AABB with initial value.
     */
    clear() {
        this.pointLBF = null;
        this.pointRTN = null;
        this._center = null;
    }
}
export default AABB;



// WEBPACK FOOTER //
// ./src/AABB.ts